import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { stockService } from "../services/stock";
import { productionService } from "../services/production"; // To get production lots
import { productService } from "../services/product"; // To get product names for display

const CreateStockEntry = () => {
  const [stockData, setStockData] = useState({
    production_lot_id: "",
    product_id: "", // Will be derived from production_lot_id
    current_quantity: 0,
    location: "",
  });

  const [productionLots, setProductionLots] = useState([]);
  const [products, setProducts] = useState([]); // To map product_id to product name
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchProductionLots();
    fetchProducts();
  }, []);

  const fetchProductionLots = async () => {
    try {
      const data = await productionService.getProductionLots();
      setProductionLots(data);
    } catch (err) {
      setError(err.message || "Erro ao carregar lotes de produção");
    }
  };

  const fetchProducts = async () => {
    try {
      const data = await productService.getProducts();
      setProducts(data);
    } catch (err) {
      setError(err.message || "Erro ao carregar produtos");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setStockData((prev) => ({
      ...prev,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Derive product_id from selected production_lot_id
    const selectedLot = productionLots.find(
      (lot) => lot.id === stockData.production_lot_id
    );
    if (!selectedLot) {
      setError("Lote de produção inválido");
      return;
    }

    const dataToSend = {
      ...stockData,
      product_id: selectedLot.product_id,
    };

    try {
      await stockService.createStockEntry(dataToSend);
      navigate("/stock");
    } catch (err) {
      setError(err.message || "Erro ao registrar entrada de stock");
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 p-8">
      <div className="container mx-auto">
        <h1 className="text-3xl font-bold text-neutral-800 mb-8">
          Registrar Nova Entrada de Stock
        </h1>

        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-md rounded-lg p-8"
        >
          {error && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
              role="alert"
            >
              {error}
            </div>
          )}

          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm text-neutral-700 mb-2">
                Lote de Produção
              </label>
              <select
                name="production_lot_id"
                value={stockData.production_lot_id}
                onChange={handleInputChange}
                required
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
              >
                <option value="">Selecione um lote</option>
                {productionLots.map((lot) => (
                  <option key={lot.id} value={lot.id}>
                    {lot.lot_number} -{" "}
                    {products.find((p) => p.id === lot.product_id)?.name ||
                      "Produto Desconhecido"}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm text-neutral-700 mb-2">
                Quantidade Atual (kg/unidades)
              </label>
              <input
                type="number"
                name="current_quantity"
                value={stockData.current_quantity}
                onChange={handleInputChange}
                required
                min="0"
                step="0.01"
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
              />
            </div>

            <div className="col-span-2">
              <label className="block text-sm text-neutral-700 mb-2">
                Localização (Opcional)
              </label>
              <input
                type="text"
                name="location"
                value={stockData.location}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
              />
            </div>
          </div>

          {/* Botões de ação responsivos */}
          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:justify-end">
            <button
              type="button"
              onClick={() => navigate("/stock")}
              className="w-full sm:w-auto bg-neutral-100 text-neutral-900 px-4 py-2 rounded-md hover:bg-neutral-200"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="w-full sm:w-auto bg-neutral-900 text-white px-4 py-2 rounded-md hover:bg-neutral-800"
            >
              Registrar Entrada
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateStockEntry;
